export class FarmModel {
    ClientId: string;
    ClientIdDV: string;
    FarmCode: string;
    AreaUOM: string;
    AreaUOMDV: string;
    BlobKey: string;
    CountyCode: string;
    ExtendedBlobKey: string;
    FarmComment: string;
    FarmName: string;
    FSANumber: string;
    FSATract: string;
    IsActive: number;
    IsIrrigated: number;
    LastModDate: Date
    Latitude: number;
    Longitude: number;
    MaximumLongitude: number;
    MinimumLatitude: number;
    MinimumLongitude: number;
    ParcelNumber: string;
    PrintNote: string;
    PropertyBlobKey: string;
    Range: string;
    ReportedArea: number;
    RowId: number;
    Section: string;
    SoilTextureCode: string;
    SpatialArea: number;
    StateCode: string;
    Township: string;
    UniversalId: string;
    WatershedCode: string;
    CreatedBy: string;
    CreatedDate: Date;
    LastUpdatedBy: string;
    LastUpdatedDate: Date;
    SQLID: string ;
    TenantID: string;
    FarmSplits: any;
    Fields: Field[];
    children: Field[];
    name:string;
    SplitNameId: string;
    NameId: string;
    NameIdDV: string;
    SplitClientId: string;
    SplitClientIdDV: string;
    IsPrimary:boolean;
    isClient: boolean;
    isNotVisible: boolean;
    isDisabled: boolean;
    isNoSplits:boolean;
}
export class Field {
    ClientId: string;
    ClientIdDV: string;
    FarmCode: string;
    FieldCode: string;
    AreaUOM: string;
    AreaUOMDV: string;
    BlobKey: string;
    CountyCode: string;
    Directions: string;
    ExtendedBlobKey: string;
    FieldName: string;
    FSAFarm: string;
    FSANumber:string;
    FSATract: string;
    IsActive: number;
    IsIrrigated: number;
    LastModDate: Date;
    LastModTime: Date;
    LastModUser: string ;
    Latitude: number;
    LegalDescription: string;
    Longitude: number;
    MaximumLatitude: number;
    MaximumLongitude: number;
    MinimumLatitude: number;
    MinimumLongitude: number;
    ParcelNumber: string;
    PropertyBlobKey: string;
    Range: string;
    ReportedArea: number;
    RowId: number;
    Section: string;
    SoilTextureCode: string;
    SpatialArea: number;
    StateCode: string;
    Township: string;
    UniversalId: string;
    WatershedCode: string;
    CreatedBy: string;
    CreatedDate: Date;
    LastUpdatedBy: string;
    LastUpdatedDate: Date;
    SQLID: string;
    TenantID: string;
    FieldSplits: FieldSplit[];
    name:string;
    FarmName:string;
    isNotVisible: boolean;
    isDisabled :boolean;
    isNoSplits:boolean;
}
export class FieldSplit {
    SplitCode: string;
    ChemicalPercent: number;
    ClientId: string;
    ClientIdDV: string;
    FarmCode: string;
    FertilizerPercent: number;
    FieldCode: string;
    LastModDate: Date;
    LastModTime: Date;
    LastModUser: string;
    LimePercent: number;
    RowId: number;
    SeedPercent: number;
    ServicePercent: number;
    SplitClientId: string;
    SplitClientIdDV: string;
    SplitLevel: number;
    SubfieldCode: string;
    CreatedBy: string;
    CreatedDate: Date;
    LastUpdatedBy: string;
    LastUpdatedDate: Date;
    SQLID: string;
    TenantID: string
}